import type { FC } from 'react';
import type { FieldProps, FieldType } from '../VerticalStepForm.model';
import SelectField from './SelectField';

const fieldRegistry: Record<FieldType, FC<FieldProps>> = {
  select: SelectField,
};

/** Resolves a field type string to its corresponding React component. */
export const resolveField = (type: FieldType): FC<FieldProps> => {
  return fieldRegistry[type];
};
